import React from 'react';
import { withTranslation } from 'react-i18next';
import BlockBike from '../blockBike/BlockBike';
import BlockBikeMap from '../blockBikeMap/BlockBikeMap';
import './ListBike.scss';

class ListBike extends React.Component<any, any> {
    listBikesFiltered = () => {
        if(this.props.listBikes.length > 0) {
            return this.props.listBikes.map((bike: any, index: number) => 
                <BlockBike 
                    displayRightPage={this.props.displayRightPage}
                    name={bike.model_name ? bike.model_name : ''}
                    brand={bike.brand ? bike.brand : ''}
                    type={bike.family ? bike.family : ''}
                    price={bike.price ? bike.price : 0}
                    link={bike.details_link ? bike.details_link : ''}
                    image={bike.image_src ? bike.image_src : ''}
                    key={index}
                />
            )
        }
    }

    render() {
        return (
            <div className="ListBike">
                { this.listBikesFiltered() }
                <BlockBikeMap displayRightPage={this.props.displayRightPage} />
            </div>
        );
    }
}

export default withTranslation()(ListBike);